import {getPriceFromProductData, hasStock, Product, ProductData} from "@/entities/product";
import {AddToWaitListButton} from "@/features/add-to-waitList";
import {BasketActionButton} from "@/features/basket-actions";
import {BuyOneClickButton} from "@/features/buyOneClick";
import {formatPrice} from "@/shared/lib/format/formatPrice";
import styles from "./ProductPurchaseBar.module.scss";

type Props = {
    product: Product;
    productDataCurrent: ProductData;
}

export const ProductPurchaseBar = ({product, productDataCurrent}: Props) => {
    const {
        current,
        original,
        hasDiscount,
        discount,
    } = getPriceFromProductData(productDataCurrent);

    return (
        <div className={styles.container}>
            <div className={styles.wrapper}>
                {hasStock(productDataCurrent?.kol) ?
                    <div className={styles.price}>
                        <p className={styles.current}>{formatPrice(current)}</p>
                        {hasDiscount && (
                            <>
                                <p className={styles.original}>{formatPrice(original)}</p>
                                <p className={styles.discount}>-{discount}%</p>
                            </>
                        )}
                    </div>
                    :
                    <p className={styles.outOfStockText}>Товар закончился</p>
                }
                <div className={styles.buttons}>
                    {hasStock(productDataCurrent?.kol) ?
                        <>
                            <BasketActionButton
                                product={product}
                                productDataId={productDataCurrent?.id}
                                size={`m`}
                                className={styles.basketButton}
                                labelClassName={styles.basketLabel}
                                fullWidth
                            />
                            <BuyOneClickButton
                                productId={product.id}
                                selectedSize={productDataCurrent?.razmer}
                                size={`m`}
                                className={styles.buyOneClickButton}
                                labelClassName={styles.buyOneClickLabel}
                                fullWidth
                            />
                        </>
                        :
                        <AddToWaitListButton
                            productId={product.id}
                            selectedSize={productDataCurrent?.razmer}
                            size={`m`}
                            className={styles.waitListButton}
                            labelClassName={styles.waitListLabel}
                            fullWidth
                        >
                            Уведомить о поступлении
                        </AddToWaitListButton>
                    }
                </div>
            </div>
        </div>
    );
}
